import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { AlarmsService } from '../services/alarms-service.service';
import * as $ from 'jquery/dist/jquery.min.js';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
    selector: 'app-water-usage-alerts',
    templateUrl: './water-usage-alerts.component.html',
    styleUrls: ['./water-usage-alerts.component.css']
})
/** water-usage-alerts component*/
export class WaterUsageAlertsComponent implements OnInit{
  showEmailWU = true;
  showPhoneWU = false
  oneAtATime = true;
  subscribedWU = false;
  emailSubscribedWU = false;
  textSubscribedWU = false;
  accountWU: any;
  accountIdWU: number;
  accountEmailWU: string;
  accountPhoneWU: string;
  accountPhonesWU: string[] = [];
  alarmsWU: any = {};
  radioModelWU = 'email';
  deleteTextWU = false;
  deleteEMailWU = false;
  percentInput: number;
  loading = true;
  acctIndexID: any;

  constructor(
    private loginService: LoginService,
    private alarmsService: AlarmsService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {

  }
  setPercentValue(val) {
    if (val === "") {
      this.percentInput = 0;
    }
    this.percentInput = parseFloat(val);
  }
  onSubscribeClick() {
    this.subscribedWU = true;
  }

  showPhoneSelect() {
    this.showEmailWU = false;
    this.showPhoneWU = true;
    this.radioModelWU = "text";
  }

  showEmailInput() {
    this.showEmailWU = true;
    this.showPhoneWU = false;
    this.radioModelWU = "email";
  }

  removeWUAlert(removeText, removeEmail) {
    this.spinnerService.show();
    let deleteModel = {
      OrgUnitId: 0,
      AccountId: this.accountIdWU,
      RemoveEmail: removeEmail,
      RemoveText: removeText,
      AlarmTypeId: 5
    };
    if (removeEmail) {
      this.alarmsService.deleteAlarm(deleteModel)
        .subscribe((res) => {
          if (res.success === true) {
            console.log('success');
            this.emailSubscribedWU = false;
          }
          else {
            console.log('failure');
          }
          () => this.spinnerService.hide();
        });
    } else {
      this.alarmsService.deleteAlarm(deleteModel)
        .subscribe((res) => {
          if (res.success === true) {
            console.log('success');
            this.textSubscribedWU = false;
          }
          else {
            console.log('failure');
          }
          () => this.spinnerService.hide();
        });
    }

  }
  onSaveWUAlertClick() {
    this.spinnerService.show();

    let accountDetails = this.accountWU.accountDetails[this.acctIndexID].accountDetails;
    let accountsWithDevices = this.accountWU.accountsWithDevices[this.acctIndexID];

    let orgUnitId = accountsWithDevices.orgUnitId;
    let DeviceId = accountsWithDevices.deviceId;

    let UserId = this.accountWU.UserId;
    let ContactMethod = this.radioModelWU;
    let ContactInfoText = '';
    let ContactInfoEmail = '';
    let AlarmType = '';
    if (this.radioModelWU === "email") {
      ContactInfoText = '';
      ContactInfoEmail = accountDetails.email;
      AlarmType = 'meter-email';
    }
    else {
      ContactInfoText = this.preparePhoneNumberForSaving(this.accountPhoneWU);
      ContactInfoEmail = '';
      AlarmType = 'meter-text';
    }
    let Active = true;
    let AccountId = accountDetails.accountId;

    let alarmObject = {
      UserId: UserId,
      DeviceId: DeviceId,
      AlarmType: AlarmType,
      ContactMethod: ContactMethod,
      ContactInfoText: ContactInfoText,
      ContactInfoEmail: ContactInfoEmail,
      Active: Active,
      AccountId: AccountId,
      OrgUnitId: orgUnitId,
      AlarmTypeId: 5,
      Buffer: this.percentInput
    }
    this.alarmsService.createAlarm(alarmObject)
      .subscribe((res) => {
        if (res.success === true) {
          console.log('success');
          this.alarmsWU = {};
          this.getWUAlarms(orgUnitId, DeviceId);
        }
        else {
          console.log('failure');
        }
        () => this.spinnerService.hide();
      });
  }
  ngOnInit() {
    this.spinnerService.show();
    this.loginService.getUserContext()
      .subscribe((account) => {
        this.accountWU = account;

        this.acctIndexID = this.getActiveAcctIndex(account.accountsWithDevices, account.activeAcctId);

        let accountsWithDevices = account.accountsWithDevices[this.acctIndexID];

        let orgUnitId = accountsWithDevices.orgUnitId;
        let DeviceId = accountsWithDevices.deviceId;
        this.getWUAlarms(orgUnitId, DeviceId);

        let accountDetails = this.accountWU.accountDetails[this.acctIndexID].accountDetails;
        this.accountEmailWU = accountDetails.email;

        if (accountDetails.homePhone !== null) {
          this.accountPhonesWU.push(this.formatPhoneNumber(accountDetails.homePhone));
        }
        if (accountDetails.cellPhone !== null) {
          this.accountPhonesWU.push(this.formatPhoneNumber(accountDetails.cellPhone));
        }
        if (accountDetails.businessPhone !== null) {
          this.accountPhonesWU.push(this.formatPhoneNumber(accountDetails.businessPhone));
        }
        () => this.spinnerService.hide();
      });
  }

  toggleAccordionWU(open = false) {
    var arrowState = $('.arrowdiv-wu');
    if (open) {
      arrowState.removeClass("fa-chevron-right");
      arrowState.addClass("fa-chevron-down");
    }
    else {
      if (arrowState.hasClass("fa-chevron-down")) {
        arrowState.removeClass("fa-chevron-down");
        arrowState.addClass("fa-chevron-right");
      } else {
        arrowState.removeClass("fa-chevron-right");
        arrowState.addClass("fa-chevron-down");
      }
    }
  }

  getWUAlarms(orgUnitId, deviceId) {
    this.alarmsService.getAlarms(orgUnitId, deviceId, "5")
      .subscribe((alarms) => {
        if (alarms.success === false) {
          this.textSubscribedWU = false;
          this.emailSubscribedWU = false;
          this.subscribedWU = false;
          this.percentInput = 10;
          console.log('user has no alarms set');
        }
        else {
          this.subscribedWU = true;
          this.alarmsWU = alarms.modelRet;
          this.accountIdWU = alarms.modelRet.accountId;
          this.percentInput = alarms.modelRet.buffer;

          if (alarms.modelRet.contactInfoText !== "" && alarms.modelRet.contactInfoText !== null) {
            this.accountPhoneWU = this.formatPhoneNumber(alarms.modelRet.contactInfoText);
            this.textSubscribedWU = true;
          }

          if (alarms.modelRet.contactInfoEmail !== "" && alarms.modelRet.contactInfoEmail !== null) {
            this.emailSubscribedWU = true;
          }
        }
      });
  }

  preparePhoneNumberForSaving(phoneNumber) {
    var result = phoneNumber.replace(/[- )(]/g, '');
    return result;
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }

  getActiveAcctIndex(accts, activeAcctID) {
    var acctIDIndex = 0;

    //get correct acct based on selected active acctid
    for (var i = 0; i < accts.length; i++) {
      let acct = accts[i];
      if (acct.accountId == activeAcctID) {
        acctIDIndex = i;
        break;
      }
    }
    return acctIDIndex;
  }
}



// WEBPACK FOOTER //
// ./src/app/water-usage-alerts/water-usage-alerts.component.ts